export const CAMPAIGN_LABEL_INCIDENT_SLUGS = {
  events_data_loss_aug_2026: 'events-data-loss-aug-2026',
} as const;

export type CampaignLabelWithIncident =
  keyof typeof CAMPAIGN_LABEL_INCIDENT_SLUGS;

export function getIncidentSlugForCampaignLabel(
  label: string
): string | undefined {
  if (label in CAMPAIGN_LABEL_INCIDENT_SLUGS) {
    return CAMPAIGN_LABEL_INCIDENT_SLUGS[label as CampaignLabelWithIncident];
  }
  return undefined;
}
